import React from "react";

import { Done } from "@mui/icons-material"
import { Box, Button, InputAdornment, ListItemIcon, MenuItem, Modal, TextField, Typography } from "@mui/material"
import Service from "../../../util/Service";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function KanbanConcluirCardModal(props) {
    const { cartao, action } = props;

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [esforco, setEsforco] = React.useState(0);
    const [msg, setMsg] = React.useState('');

    React.useEffect(() => {
        if (open) {
            console.log(cartao);
            // const dtCriacao = new Date(cartao.dtCriacao);
            let tempo = cartao.esforco;

            let dtH = new Date().getTime(); //(cartao.historico && cartao.historico.length> 0)?cartao.historico[0].dt: new Date().getTime();
            let txt = "Tempo da criação ate a data autal";
            const item = cartao.historico.find(f => f.desc.indexOf("Moveu") >= 0);
            console.log(item);
            if (item) {
                dtH = item.dt;
                txt = "Tempo da criação ate a ultima movimentação do cartão";
            }
            const diff = dtH - cartao.dtCriacao;
            tempo = diff / (1000 * 60 * 60);
            console.log(tempo);
            if (tempo > 24) {
                tempo = (tempo * 8) / 24;
                txt = "Essa atividade demorou mais de um dia para ser concuida, considerando o dia como 8 horas."
            }
            if (tempo < cartao.esforco) {
                tempo = cartao.esforco;
                txt = "Tempo da criação ate a conclusão do cartão é inferior ao esforço definido. Pegando o esforço definido"
            }
            console.log(tempo);
            if (tempo < 1) {
                tempo = 1;
                txt = "Tempo de uma hora, tempo minimo para criação do card";
            }

            console.log(tempo);
            setEsforco(Math.floor(tempo));
            setMsg(txt)
        }
    }, [open])

    function handleConcluirAtividade(){
        const dado = {
            id: cartao.id,
            esforco: esforco,
            concluido: true,
        }

        console.log( dado );

        Service.POST('/api/security/projeto/kanban/cardConcluido', dado).then(r =>{
            console.log( r );
            if( r.success){
                if( action )action(r.dado);
            }else{
                alert(r.msg );
            }

        })
    }
    return (
        <React.Fragment>
            <MenuItem onClick={handleOpen}>
                <ListItemIcon size='small'>
                    <Done fontSize="small" />
                </ListItemIcon>
                Concluir Atividade
            </MenuItem>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Indique o tempo gasto para concluir a atividade
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                        {msg}
                    </Typography>

                    <TextField fullWidth
                        label="Esforço" size='small' type="number"
                        // sx={{ ml: 5, width: '15ch' }}
                        value={esforco} onChange={e => setEsforco(e.target.value)}
                        slotProps={{
                            input: {
                                endAdornment: <InputAdornment position="end">Horas</InputAdornment>,
                            },
                        }}
                        variant="outlined"
                    />
                    <div style={{
                        height: '80px',
                        alignItems: 'center', justifyContent: 'center'
                        , display: 'flex', flexDirection: 'row', gap: '1rem'
                    }}>
                        <Button variant="outlined" onClick={handleClose}>Fechar</Button>
                        <Button variant="outlined" onClick={handleConcluirAtividade}>Concluir</Button>
                    </div>
                </Box>
            </Modal>

        </React.Fragment>

    )
}